import { Component, OnInit } from '@angular/core';
import {LoginService} from '../services/login.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TokenService } from '../services/token.service';
import { EncryptionService } from '../services/encryption.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [MessageService]
})
export class LoginComponent implements OnInit {
  id : string;
  mdp: string;

  constructor(private router: Router, private loginService: LoginService, private msgService: MessageService, private tokenService : TokenService, private encryptService:EncryptionService) { }

  ngOnInit(): void {
    let isLogged : boolean = this.loginService.checkIsLogged();
    console.log(isLogged);
    (isLogged) ? this.router.navigate(['/historique']) : '';
  }

  login() {
    /*let result = this.loginService.getUsers(parseInt(this.id), this.mdp);*/
    this.loginService.checkLogin(this.id, this.mdp).subscribe(data => {
        // console.log('Data'+ JSON.stringify(data));
        if (data['status'] === 'userfound' && data['mdpstatus'] === true) {
          localStorage.clear();
          localStorage.setItem('isLoggedin', 'true');
          const user = data['user'];
          let localEncrypted = this.encryptService.encrypt(JSON.stringify(user));
          localStorage.setItem('user', localEncrypted);
          this.tokenService.startRefreshToken();
          // tslint:disable-next-line:forin
/*          for (const key in user) {
            localStorage.setItem('' + key, '' + user[key]);
          }*/

          if(parseInt(user['droit']) === 3) {
            this.router.navigate(['/reporting']);
          } else {
            this.router.navigate(['/moderation']);
          }
          
          //  this.timer_stop();
        } else if (data['status'] === 'usernotfound') {
          // this.loginHasError = true;
          // this.loginError = 'L\'identifiant n\'est pas valide, veuillez réessayer';
          this.errorLogin();
        } else {
          // window.alert('');
          // console.log(data);
          // this.loginHasError = true;
          // this.loginError = 'Votre mot de passe est incorrect, Veuillez réessayer';
          this.errorLogin();
        }
      },
      (error: any) => {
        this.errorLogin();
      });
  }
  errorLogin() {
    this.msgService.add({
      severity: 'error',
      summary: 'Erreur login',
      detail: 'Login ou mot de passe erroné'
    });
  }

}
